const translations = {
    'tier.city': 'Metropolia',
    'tier.outpost': 'Posterunek',
    'tier.town': 'Miasto',
};

export default translations;
